exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-section[data-v-530a371b] {\n  max-height: 650px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  cursor: pointer;\n}\n@media (min-width: 1921px) {\n.video-section[data-v-530a371b] {\n    max-height: 800px;\n}\n}\n.video-section img[data-v-530a371b] {\n  width: 100%;\n}", ""]);

// exports
